export default "__VITE_ASSET__DGKo0fn$__"